import { render, staticRenderFns } from "./ExportLink.vue?vue&type=template&id=6c4895b4&scoped=true"
import script from "./ExportLink.vue?vue&type=script&lang=js"
export * from "./ExportLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4895b4",
  null
  
)

export default component.exports